import { render, staticRenderFns } from "./GlobalMarginAndPriceCalculationDialog.vue?vue&type=template&id=fc5b825a&scoped=true"
import script from "./GlobalMarginAndPriceCalculationDialog.vue?vue&type=script&lang=js"
export * from "./GlobalMarginAndPriceCalculationDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalMarginAndPriceCalculationDialog.vue?vue&type=style&index=0&id=fc5b825a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5b825a",
  null
  
)

export default component.exports